document.addEventListener("DOMContentLoaded", () => {
    // BSS B2B v3: the observer has no emit(); notify through the product subject instead.
    const emitVariantChange = (payload) => {
        const observer = BSS_B2B.observer.productObserver;
        if (typeof observer.emit === 'function') return observer.emit('VariantChange', payload);
        return BSS_B2B.observer.productSubject?.notifyObserver('VariantChange', 'VariantSelectChange', payload);
    };

    // Wait for the BSS_B2B app to finish initializing its object and storage
    const fixB2bPriceInterval = setInterval(() => {
        if (window.BSS_B2B?.storage?.productFormStorage && window.BSS_B2B?.observer?.productObserver) {
            clearInterval(fixB2bPriceInterval); // Stop the interval once the app is ready

            // BSS B2B v3: Storage has no entries(); getAll() returns a cloned Map, so changes must be saved back with set().
            const formEntries = BSS_B2B.storage.productFormStorage.getAll().entries();

            for (const [formId, product] of formEntries) {
                const rows = document.querySelectorAll('.ck-php-ms-row');

                // If the custom multi-select UI is found
                if (rows.length > 0) {
                    const originalCurrentVariant = product.currentVariant;   
  
                    // 1. Trick the TD & PL modules into multi-row render mode (Quick Order)
                    product.location = 'quick_order_list';
                    BSS_B2B.storage.productFormStorage.set(formId, product);

                    rows.forEach(row => {
                        const variantIdStr = row.getAttribute('data-variant-id');
                        if (!variantIdStr) return;

                    const variantId = Number(variantIdStr);

                        // 2. Remove the default PDP attribute so the app no longer falls into the wrong `else` branch
                        const priceEl = row.querySelector('[bss-b2b-product-price]');
                        if (priceEl) {
                            priceEl.removeAttribute('bss-b2b-product-price');
                        } 

                        // 3. Get the variant data from the app's storage
                        const variantItem = BSS_B2B.storage.variantStorage.get(variantId);

                        if (variantItem) {
                            // Force the app to treat this row's variant as the "currentVariant"
                            product.currentVariant = variantItem;
                            BSS_B2B.storage.productFormStorage.set(formId, product);

                            // 4. Emit the VariantChange event
                            // -> TD and PL modules will call this.getPrice() to recalculate the price for this variant
                            // -> Then call showPrice() -> enter the `quick_order_list` branch -> render into the matching HTML row
                            emitVariantChange({
                                formId: formId,
                                formIdMapProducts: BSS_B2B.storage.productFormStorage
                            });
                        }
                    });

                    // 5. Restore the original currentVariant so Shopify's original Add to cart button doesn't break
                    product.currentVariant = originalCurrentVariant;
                    BSS_B2B.storage.productFormStorage.set(formId, product);

                    // Trigger one final time for the real currentVariant to sync state
                    emitVariantChange({
                        formId: formId,
                        formIdMapProducts: BSS_B2B.storage.productFormStorage
                    });
                }
            }
        }
    }, 250);

    // Clear the interval after 10s in case the BSS app fails to load
    setTimeout(() => clearInterval(fixB2bPriceInterval), 10000);
});

// Hide the retail compare-at price once BSS has replaced the price with a B2B one, so
// a B2B customer never sees a strikethrough against a price that is no longer the one
// being compared. Markup comes from snippets/price.liquid:
//   .bss-price-container       wrapper around one price group 
//   .compare-at-price-wrapper  the strikethrough group to hide 
//   data-bss-original-price    the Liquid-rendered price text
//
// "BSS changed it" = live text differs from data-bss-original-price. A theme-driven
// variant swap re-renders the container from the server, so the text and the data
// attribute move together and this never trips on the theme's own updates.
(function () {
    const SELECTOR = "[bss-b2b-product-price][data-bss-original-price]";
    let queued = false;

    function sync(priceEl) {
        const container = priceEl.closest(".bss-price-container");
        if (!container) return;

        const original = (priceEl.getAttribute("data-bss-original-price") || "").trim();
        const changed = original !== "" && priceEl.textContent.trim() !== original;

        container.querySelectorAll(".compare-at-price-wrapper").forEach((wrapper) => {
            wrapper.style.display = changed ? "none" : "";
        });
    }

    function syncAll() {
        queued = false;
        document.querySelectorAll(SELECTOR).forEach(sync);
    }

    function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(syncAll);
    }

    // childList/characterData only — this writes inline styles, so observing
    // attributes would feed the observer its own changes.
    new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        characterData: true,
        subtree: true,
    });

    schedule();
    document.addEventListener("DOMContentLoaded", schedule);
})();
